"use client";

import { useLayoutEffect, useState } from "react";

const useMobile = (initialIsMobileFromServer: boolean = false) => {
  const [isMobile, setIsMobile] = useState<boolean>(initialIsMobileFromServer);

  const checkMobile = () => {
    if (typeof window !== "undefined") {
      const isUserAgentMobile = /iPhone|iPad|iPod|Android/i.test(
        navigator.userAgent,
      );
      const isWindowWidthMobile = window.innerWidth <= 768;
      setIsMobile(isUserAgentMobile || isWindowWidthMobile);
    }
  };

  useLayoutEffect(() => {
    checkMobile(); // Ensure we run the check immediately after mounting.

    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return isMobile;
};

export default useMobile;
